export default __webpack_public_path__ + "static/assets/med_pill_round_in_L0_solid_s_01_f_mask.606baa11.png";